import { FormattedMessage } from 'react-intl';
import Button from '@rio-cloud/rio-uikit/Button';
import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';
import { DriverStatus } from '../../../../../types';

interface FooterProperties {
    currentDriverStatus: DriverStatus | null | undefined;
    isSaveButtonEnabled: boolean;
    onDelete: () => void;
    onSave: () => void;
    onStatusActionClick: () => void;
    statusActionDisabled: boolean;
}

export const Footer = (props: FooterProperties) => {
    const { currentDriverStatus, isSaveButtonEnabled, onSave, onDelete, onStatusActionClick, statusActionDisabled } =
        props;
    const statusActionIsArchive = currentDriverStatus === DriverStatus.ACTIVE;
    const deleteButton = (
        <Button
            autoTrackingKey='drivers.sidebar.delete'
            bsStyle={Button.DANGER}
            variant={Button.VARIANT_LINK}
            iconName='icon-trash'
            onClick={onDelete}
            data-testid='detailViewDeleteButton'
        >
            <FormattedMessage id={'intl-msg:delete'} />
        </Button>
    );

    return (
        <ButtonToolbar className='align-items-center' alignment='space-between'>
            <div className='display-flex gap-5'>
                {deleteButton}
                <Button
                    autoTrackingKey={statusActionIsArchive ? 'drivers.sidebar.archive' : 'drivers.sidebar.activate'}
                    variant={Button.VARIANT_LINK}
                    iconName={statusActionIsArchive ? 'icon-lock' : 'icon-lock-open'}
                    disabled={statusActionDisabled}
                    onClick={onStatusActionClick}
                    data-testid='detailViewStatusActionButton'
                >
                    {statusActionIsArchive ? (
                        <FormattedMessage id='intl-msg:drivers.sidebar.archive' />
                    ) : (
                        <FormattedMessage id='intl-msg:drivers.sidebar.activate' />
                    )}
                </Button>
            </div>
            <Button
                autoTrackingKey='drivers.sidebar.save'
                bsStyle={Button.PRIMARY}
                onClick={onSave}
                disabled={!isSaveButtonEnabled}
                data-testid={'detailViewSaveButton'}
            >
                <FormattedMessage id={'intl-msg:save'} />
            </Button>
        </ButtonToolbar>
    );
};
